<template>
  <section class="mainText ">
    <b-container fluid="xl">
        <b-row id="main1" class="maintText__row">
            <b-col cols="12" class="pb-5 side-gap">
                <h2 style="mainText__mainName--maintxtx">
                    FOMO 
                </h2>
                <p class="hashText">- A kimaradástól való félelem, ami mindenkit érint</p>
            </b-col>
        </b-row>
        <b-row class="maintText__row">
            <b-col cols="12" lg="6">
            <div class="maintText__txt-content pb-lg-5 pb-2">
                <p class="text">
                Biztos ismerős az érzés, amikor pörgeted az Instagramot, és úgy tűnik, mintha mindenki mással történne valami izgalmas. Valaki egy fesztiválon van, mások nyaralnak, egy régi ismerős épp szerelmes, és úgy tűnik, te vagy az egyetlen, aki otthon ül, melegítőben, egy random csésze teával. Ez a FOMO – vagyis a Fear of Missing Out – jelenség, amit a közösségi média csak még jobban felerősít.</p>

                <p class="text">
                A FOMO nemcsak egy múló érzés. Egy olyan állapot, ami folyamatos hiányérzetet kelt. Nem arról van szó, hogy nem történik veled semmi jó – hanem hogy mások életét mindig a legjobb pillanataik alapján látod, a sajátodat pedig a valóság alapján éled meg. És ez óriási különbség.
                </p>

                <p class="text">
                A közösségi média „highlightokat” mutat, vagyis a legjobbra vágott részeket. Ez pont olyan, mintha valaki egy egész filmről csak az előzetest látná, és az alapján próbálná megítélni a történetet. Csak itt te vagy a néző – és a főszereplő is. Csak hát a te filmed nem folyamatos utazásból, partikból meg naplementés sétákból áll. És ez teljesen rendben van.</p>

                <p class="text">
                Fontos megérteni, hogy a kimaradástól való félelem nem feltétlenül arról szól, hogy tényleg le is maradunk valamiről. Inkább arról, hogy nem tudunk jelen lenni ott, ahol épp vagyunk, mert fejben mindig máshol járunk. A többiek sztorijában, az el nem ment eseményen, a „mi lett volna, ha…” gondolatban.</p>
                <p class="text">
                Ha te is gyakran érzed úgy, hogy mások élete valahogy érdekesebb, izgalmasabb, vagy jobban halad, akkor érdemes egy pillanatra megállni. Mert az élet nem folyamatosan zajló élményverseny. A legfontosabb pillanatok gyakran csendesek, és egyáltalán nem látványosak. Az önismeret, a fejlődés, a megnyugvás nem trendelhető online.</p>
                <p class="text">
                És ami a legfontosabb: nem maradsz le semmiről, amit neked szántak. Csak néha el kell engedned a többiek tempóját, hogy megtaláld a sajátod.</p>
            </div>
            </b-col>
            <b-col cols="12" lg="6" class="order-4 order-lg-1">
              <img src="images/fomo.jpg" class="w-100 margin-top-sm-44 mb-4"/>
          </b-col>
        </b-row>
    </b-container>
    <Articles :isFirst="true"/>
  </section>
</template>
<script>
import Articles from '../components/Articles.vue'

export default {
  components: {
    Articles
  },
  mounted(){

    this.setMetaTags({        
        title: "FOMO – A kimaradástól való félelem, ami mindenkit érint", 
        desc: "Biztos ismerős az érzés, amikor pörgeted az Instagramot, és úgy tűnik, mintha mindenki mással történne valami izgalmas. ", 
        keywords: null, 
        ogType: 'website', 
        ogTitle: "FOMO – A kimaradástól való félelem, ami mindenkit érint",
        ogImage: null, 
        ogImageWidth: null, 
        ogImageHeight: null, 
        ogDesc: "Biztos ismerős az érzés, amikor pörgeted az Instagramot, és úgy tűnik, mintha mindenki mással történne valami izgalmas. "        
    })
  }
}
</script>